var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"inputautocomplete",staticClass:"form-control",attrs:{"type":"text","id":_vm.id_input,"placeholder":_vm.titulo},domProps:{"value":_vm.value}}),_vm._v(" "),_c('div',{staticClass:"autocomplete-suggestions",attrs:{"id":_vm.id_div}})])
}
var staticRenderFns = []

export { render, staticRenderFns }